/**
 * @generated SignedSource<<008f0b00bcb43ef8b5c2b07a5302da17>>
 * @relayHash 52f8d8b83057b57b928e02a12bb034ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c4aeb50f4fe5245ed2a85ba1c37766ef3d3bf0dc0ca6b17e9aefe76825492c34

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_autodevAgentPickerBulkQuery$variables = {
  cloudId: string;
  issueAris: ReadonlyArray<string>;
};
export type ui_autodevAgentPickerBulkQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pickerContent_autodevAgentPicker_agentsFragRef">;
};
export type ui_autodevAgentPickerBulkQuery = {
  response: ui_autodevAgentPickerBulkQuery$data;
  variables: ui_autodevAgentPickerBulkQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider": isVerticalsAgentPickerEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isVerticalsAgentPickerEnabled_provider from '@atlassian/jira-relay-provider/src/autodev-is-verticals-agent-picker-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueAris"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ui_autodevAgentPickerBulkQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "issueAris",
            "variableName": "issueAris"
          }
        ],
        "kind": "FragmentSpread",
        "name": "pickerContent_autodevAgentPicker_agentsFragRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ui_autodevAgentPickerBulkQuery",
    "selections": [
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v2/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 20
              },
              {
                "kind": "Variable",
                "name": "issueIds",
                "variableName": "issueAris"
              }
            ],
            "concreteType": "DevAiRovoAgentConnection",
            "kind": "LinkedField",
            "name": "devai_autodevRovoAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "DevAiRovoAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "DevAiRovoAgent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "identityAccountId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "externalConfigReference"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "rankCategory"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "devai_autodevRovoTemplates",
            "args": [
              (v2/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              },
              {
                "kind": "Literal",
                "name": "templatesFilter",
                "value": "ONLY"
              }
            ],
            "concreteType": "DevAiRovoAgentConnection",
            "kind": "LinkedField",
            "name": "devai_autodevRovoAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "DevAiRovoAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "DevAiRovoAgent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c4aeb50f4fe5245ed2a85ba1c37766ef3d3bf0dc0ca6b17e9aefe76825492c34",
    "metadata": {},
    "name": "ui_autodevAgentPickerBulkQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider": isVerticalsAgentPickerEnabled_provider
    }
  }
};
})();

(node as any).hash = "fac0ed7e2f112b00391a0c79b3d87b29";

export default node;
